<div *ngIf='!isSystemIdOpen' class="fade show systemId_partner_content" id="SystemIdPartnerContentTab">
    <div class="d-flex flex-column h-100" id="systemIdConFlex">
        <!--Data Heading and description-->
        <div class="data_header" id="reviewPCDataHeader">
            <div class="results_info mb-3" id="systemResultsInfo">
                <div class="title" id="SystemIdTitle">
                    <span i18n="@@system-ids.systemids.tile.systemids">System IDs</span>
                </div>
                <ng-container *ngTemplateOutlet="topShowtoFromPartner"></ng-container>
            </div>
            <div class="systemId-drop-search">
                <div class="left-content">
                    <div ngbDropdown class="dropdown" container="body" *ngIf="partner?.length" id="systemIdPCDropDown">
                        <button class="btn btn-primary dropdown-toggle" id='approveSystemIdDropdown' type="button"
                            ngbDropdownToggle>
                            {{selectedButton}}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="approveDropdown" class="dropdown-menu dropdown_scroll"
                            id="systemIdPCDropDown">
                            <ng-container *ngFor="let data of partner,let i = index">
                                <ng-container *ngIf="partnerLabel !== data">
                                    <button (click)='selectedPartnerList(data, partnerID[i])'
                                        class="dropdown-item">{{data}}</button>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                    <!--search systemId-->
                    <div class="search_group" *ngIf="selectedButton !== 'Select Partner'" id="searchGrp">
                        <div class="input-group" id="inputGrp">
                            <input #searchValue [(ngModel)]="searchData" type="text"
                                (keyup.enter)="searchSytemIDOnEnter(searchData)" maxlength="75" value=""
                                (ngModelChange)="onSystemIdSearchInput($event)" class="form-control"
                                placeholder="{{searchSystemIDPlaceHolderText}}" />
                            <img *ngIf="searchData?.length" (click)="clearSystemIdSearch()" alt="close"
                                class="search-clear-icon">
                        </div>
                        <button type="button" (click)="searchSystemIdReport(searchData)"
                            class="btn btn-primary search_btn">
                            <img class="searchicon" alt="search" />
                        </button>
                    </div>
                </div>
                <!--Delete SystemId Button-->
                <div class="delete-systemId"
                    *ngIf="(selectedButton !== 'Select Partner' && paginationCount > 1 && !systemIDDataSearch)">
                    <button *ngIf="!systemIdDeleteEnable" class="btn btn-outline-primary btn-lg"
                        (click)="multiDeleteSystemId()"><img class="delete-img" alt="Delete" />&nbsp;<span
                            i18n="@@system-ids.delete-multiple-system-ids-btn.delete-multiple-system-ids">Delete
                            Multiple System IDs</span></button>
                    <button *ngIf="systemIdDeleteEnable" (click)="resetSystemIdDelete()"
                        class="btn btn-outline-primary btn-sm"><span i18n="@@delete-popup.cancel">Cancel</span></button>
                    <button *ngIf="systemIdDeleteEnable" [disabled]="noSystemIdSelected" id="delete-systemId-id"
                        class="btn btn-outline-primary btn-lg" (click)="deleteMultiSelectSystemIds()"><img
                            class="delete-img" alt="Delete sytemId" /><span>{{globConst.DEL_SELECTED}}</span></button>
                </div>
            </div>
        </div>
        <div class="mt-3 mb-3 d-flex" id="systemIdConDFlex">
            <div class="tab-container" id="systemIDtabContainer"></div>
        </div>
        <div class="text-center"
            *ngIf="!spinnerStatus && displaySystemIDs?.length === 0 && !isSystemIDSearch && selectedButton !== 'Select Partner'"
            id="noSystemId" [ngClass]="displaySystemIDs?.length === 0 ? 'existing_text_show': 'existing_text_hide'">
            <span i18n="@@system-ids.partner-did-not-create-txt.partner-did-not-create-any-system-id">Partner did not
                create any System IDs.</span>
        </div>
        <div class="text-center" *ngIf="!spinnerStatus" id="sytemIdselectedBtn"
            [ngClass]="selectedButton === 'Select Partner' && !isPartnerEmpty ? 'existing_text_show': 'existing_text_hide'">
            <span i18n="@@system-ids.please-select-a-partner-txt.please-select-a-partner-to-view-system-ids">Please
                select a Partner to view the System IDs</span>
        </div>
        <div class="text-center" *ngIf="systemIDDataSearch && isSystemIDSearch" id="dataProfileSearchFound">
            <span i18n="@@active-users.expand.no-records-found">No Records Found</span>
        </div>
    </div>
</div>
<!--Templates-->
<ng-template #topShowtoFromPartner>
    <div class="results" id="topShowtoFromPartner">
        <span i18n="@@system-ids.systemid-results.showing-of-system-ids">Showing <strong>{{ showFrom }} - {{ showTo }}
            </strong> of <strong> {{ paginationCount }} System
                IDs</strong></span>
    </div>
</ng-template>
<!--System ID Table-->
<div *ngIf='selectedButton !== "Select Partner"' id="seletedBtnPartner">
    <div class="table-responsive" id="isSystemIdDatSelected">
        <div *ngIf="displaySystemIDs?.length" id="displaySystemIDsLength">
            <table id="systemIdTable" class="table table-borderless" [ngClass]="{'remove-margin':isNoneSelected}"
                aria-describedby="sytemIdTableData">
                <thead>
                    <tr>
                        <th *ngIf="systemIdDeleteEnable" scope="col">
                            <span class="table_headings">
                                <input type="checkbox" name="systemId_all" [(ngModel)]='isMasterSel'
                                    (change)="checkUncheckAll($event.target.checked)" />
                            </span>
                        </th>
                        <th scope="col">
                            <span class="table_headings">
                                <span i18n="@@view.info-section.systemId">System ID</span>
                                <span class="chevron_expand" (click)="sort('systemID')"></span>
                            </span>
                        </th>
                        <th scope="col">
                            <span class="table_headings">
                                <span i18n="@@view.info-section.systemModels">System Models</span>
                                <span class="chevron_expand" (click)="sort('systemModels')"></span>
                            </span>
                        </th>
                        <th scope="col">
                            <span class="table_headings">
                                <span i18n="@@model-sku-info.table.status">Status</span>
                                <span class="chevron_expand" (click)="sort('detectionStatus')"></span>
                            </span>
                        </th>
                        <th scope="col">
                            <span class="table_headings">
                                <span i18n="@@model-sku-info.table.lastupdated">Last Updated</span>
                                <span class="chevron_expand" (click)="sort('updatedTime')"></span>
                            </span>
                        </th>
                        <th scope="col">
                            <span class="table_headings">
                                <span i18n="@@model-sku-info.table.lastupdatedby">Last Updated By</span>
                                <span class="chevron_expand" (click)="sort('editedByName')"></span>
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let data of displaySystemIDs, let i = index">
                        <tr class="row_hover">
                            <!-- Check boxes for delete -->
                            <td *ngIf="systemIdDeleteEnable">
                                <input type="checkbox" id="checkSystemIdDeleteEnable" name="checkSystemIdDeleteEnable"
                                    [checked]='isAllSelectedData.has(data?.autoID)' (change)="isAllSelected(data)" />
                            </td>
                            <td>{{data.systemID}}</td>
                            <td *ngIf="checkIfList(data.systemModels)">{{data.systemModels}}</td>
                            <td *ngIf="!checkIfList(data.systemModels)">
                                <span *ngIf="data.systemModels[2]==='tooltip'" [ngbTooltip]="data.systemModels[1]">
                                    {{data.systemModels[0]}}
                                </span>
                                <span
                                    *ngIf="data.systemModels[2]==='popup1' || data.systemModels[2]==='popup2'">{{data.systemModels[0]}}</span>
                                <span *ngIf="data.systemModels[2]==='popup1'" [ngbPopover]='popUp' class="popup-badge"
                                    [popoverTitle]="data.systemModels[1].length + ' System Models'" placement="right">
                                    +{{data.systemModels[1].length - 1 }} </span>
                                <span *ngIf="data.systemModels[2]==='popup2'" [ngbPopover]='popUp' class="popup-badge"
                                    [popoverTitle]="data.systemModels[1].length + ' System Models'" placement="right">
                                    +{{data.systemModels[1].length - 2 }} </span>
                            </td>
                            <td>
                                <div class="status_column">
                                    <em *ngIf="data.detectionStatus === 'approved'" class="approved_icon"></em>
                                    <em *ngIf="data.detectionStatus === 'submitted'" class="submitted_icon"></em>
                                    <em *ngIf="data.detectionStatus === 'returned'" class="returned_icon"></em>
                                    <em *ngIf="data.detectionStatus === 'delete requested'"
                                        class="delete_req_icon"></em>
                                    <span
                                        [ngClass]="data.detectionStatus === 'delete requested' ? 'delete_Req_txt' : ''">{{checkStatusCase(data.detectionStatus)}}</span>
                                    <img *ngIf="data.detectionStatus === 'approved'" class="info_circle_icon"
                                        placement="top" [popoverTitle]="approvepop"
                                        [ngbPopover]="oemConst.APPROVED_POPOVER_TXT" container="body" alt="Approved"
                                        triggers="mouseenter:mouseleave" />
                                    <img *ngIf="data.detectionStatus === 'submitted'" class="info_circle_icon"
                                        placement="top" [popoverTitle]="submitpop"
                                        [ngbPopover]="oemConst.SUBMITTED_POPOVER_TXT" container="body" alt="submitted"
                                        triggers="mouseenter:mouseleave" />
                                    <img *ngIf="data.detectionStatus === 'delete requested'" class="info_circle_icon"
                                        placement="top" [popoverTitle]="deleteReqPopUp"
                                        [ngbPopover]="oemConst.DELETED_POPOVER_TXT" container="body"
                                        alt="delete requested" triggers="mouseenter:mouseleave" />
                                    <img *ngIf="data.detectionStatus === 'returned' && data.errorCode === 'EXISTS'"
                                        class="info_circle_icon status_popup" placement="top" [popoverTitle]="returnpop"
                                        [ngbPopover]="oemConst.RETURNED_EXISTS_POPOVER_TXT" container="body"
                                        alt="Exists" triggers="mouseenter:mouseleave" />
                                    <img *ngIf="data.detectionStatus === 'returned' && data.errorCode === 'NOT_FOUND'"
                                        class="info_circle_icon status_popup" placement="top" [popoverTitle]="returnpop"
                                        [ngbPopover]="oemConst.RETURNED_NOT_FOUND_POPOVER_TXT" container="body"
                                        alt="Not found" triggers="mouseenter:mouseleave" />
                                    <img *ngIf="data.detectionStatus === 'returned' && data.errorCode === 'PATTERN_CONFLICT'"
                                        class="info_circle_icon status_popup" placement="top" [popoverTitle]="returnpop"
                                        [ngbPopover]="patternConflictPopup" container="body" alt="pattern conflict"
                                        triggers="mouseenter:mouseleave" />
                                    <img *ngIf="data.detectionStatus === 'returned' && data.errorCode === 'VALIDATION'"
                                        class="info_circle_icon status_popup" placement="top" [popoverTitle]="returnpop"
                                        [ngbPopover]="oemConst.RETURNED_VALIDATION_POPOVER_TXT" container="body"
                                        alt="validation" triggers="mouseenter:mouseleave" />
                                    <img *ngIf="data.detectionStatus === 'returned' && data.errorCode === 'ERROR'"
                                        class="info_circle_icon status_popup" placement="top" [popoverTitle]="returnpop"
                                        [ngbPopover]="oemConst.RETURNED_ERROR_POPOVER_TXT" container="body" alt="error"
                                        triggers="mouseenter:mouseleave" />
                                </div>
                            </td>
                            <td>{{data.updatedTime | dateFormat:'changeToLocalTimeZone'}}</td>
                            <td>{{data.editedByName}}</td>
                            <td class="action_cell" *ngIf="noSystemIdSelected">
                                <button type="button" id="system_id_delete_button" class="btn btn-link delete-user"
                                    [ngbTooltip]="deleteTooltip"
                                    (click)="openSystemIdDeletePopup(data?.autoID, data?.systemID)">
                                    <img class="deleteicon" alt="systemId_delete" />
                                </button>
                            </td>
                        </tr>
                        <iposcen-delete-popup #deleteSystemIdModal [contentName]="sytemIDName"
                            [isMultisystemIddelete]="isSingleSystemIdSelected" [isSystemIDContent]="true"
                            (delete)="deleteSystemIdContent(sytemIdToDelete)">
                        </iposcen-delete-popup>
                        <iposcen-delete-acknowledgement-dialog #deleteAckModal [isSystemIDDeleteCnfrm]="true"
                            [isMultisystemIddelete]="isSingleSystemIdSelected">
                        </iposcen-delete-acknowledgement-dialog>
                        <ng-template #patternConflictPopup>
                            <span>System Model Pattern is conflicting with {{data?.conflictingModelId}}. System Model
                                pattern
                                should be unique</span>
                        </ng-template>
                        <ng-template #popUp>
                            <div>
                                <div
                                    [ngClass]="{'popup-size-scroll':data.systemModels[1].length>5,'popup-size':data.systemModels[1].length<=5}">
                                    <ul class='reduceLeftPad' *ngFor='let popupList of data.systemModels[1]'>
                                        <li class="child">{{popupList}}</li>
                                    </ul>
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>
<hr *ngIf='selectedButton !== "Select Partner" && partner?.length>0' [ngClass]="{'remove-margin-top':isNoneSelected}" />
<ng-template #approvepop>
    <div id="approvedText" class="d-flex"><em class="approved_icon mr-2"></em>
        <span i18n="@@model-sku-info.template.approved">Approved</span>
    </div>
</ng-template>
<ng-template #submitpop>
    <div id="submittedText" class="d-flex"><em class="submitted_icon mr-2"></em>
        <span i18n="@@model-sku-info.template.submitted">Submitted</span>
    </div>
</ng-template>
<ng-template #returnpop>
    <div id="returnedText" class="d-flex"><em class="returned_icon mr-2"></em>
        <span i18n="@@model-sku-info.template.returned">Returned</span>
    </div>
</ng-template>
<ng-template #deleteReqPopUp>
    <div id="DeleteReqText" class="d-flex"><em class="delete_req_icon mr-2"></em>
        <span i18n="@@system-ids.delete-req-txt.delete-requested">Delete Requested</span>
    </div>
</ng-template>
<!--Pagination-->
<div class="data_footer position-relative" *ngIf="selectedButton !== 'Select Partner' && partner?.length>0"
    id="dataFooter">
    <div class="d-flex flex-column align-items-center" id="alignPagination">
        <div *ngIf="displaySystemIDs?.length" id="systemIDContentsLength">
            <nav aria-label="content pagination">
                <ngb-pagination [collectionSize]="paginationCount" [(page)]="page" [pageSize]="tableSize"
                    [rotate]="false" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"
                    (pageChange)="onTableDataChange($event)">
                </ngb-pagination>
            </nav>
        </div>
        <div *ngIf='displaySystemIDs?.length' class="results mt-2" id="shwoFrm">
            <span i18n="@@system-ids.systemid-results.showing-of-system-ids">Showing <strong>{{ showFrom }}
                    - {{ showTo }} </strong> of <strong> {{ paginationCount }} System IDs</strong></span>
        </div>
    </div>
</div>
<iposcen-spinner-overlay (getStatus)="spinnerStatus = $event"></iposcen-spinner-overlay>